/**
 * Legal-pages host detection.
 *
 * Production:  legal.meitre.com
 * Local dev:   localhost:8080?legal=1
 *
 * The legal host serves tenant-less, neutral-brand corporate legal documents
 * (privacy policy, terms & conditions, terms of service) — Meitre's own pages,
 * not a restaurant's. Like the group host, it must NOT mount
 * TenantProvider/TenantGuard.
 */

/** Pure: does this hostname denote the legal host? Testable regardless of env. */
export function isLegalHostname(hostname: string): boolean {
  return hostname.startsWith('legal.');
}

export function isLegalHost(): boolean {
  if (import.meta.env.DEV) {
    return new URLSearchParams(window.location.search).has('legal');
  }
  return isLegalHostname(window.location.hostname);
}
